const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi43NCAyLjI1MkwyMi4yMzYgMTIgMi43NCAyMS43NDhsMS4zNjUtOS41NTUuNzcyLS4xOTMtLjc3Mi0uMTkzTDIuNzQgMi4yNTJ6bTIuNTIgMy40OTZsLjYzNSA0LjQ0NUwxMy4xMjMgMTJsLTcuMjI4IDEuODA3LS42MzUgNC40NDVMMTcuNzY0IDEyIDUuMjYgNS43NDh6IiAgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export {
  M as default
};
//# sourceMappingURL=send-e02656e4.mjs.map
